import { Provider } from 'react-redux';

import store from '~redux/store';

const Wrapper = ({ element }: { element: React.ReactElement }) => {
    return <Provider store={store}>{element}</Provider>;
};

export default Wrapper;
